// src/views/words-list/slice/actions.ts
/* eslint-disable max-len */
import { AxiosError } from 'axios';
import { message } from 'antd';
import slice from './slice';
import history from '../../../getBrowserHistory';
import { ApiError } from '../../../services/ApiService.types';
import { AppThunk } from '../../../redux/store';
import API from '../../../services/ApiService';
import { Path } from '../../../constants/Path';
import { fetchFolderTreeWithLists } from '../../folders/slice/actions';
import i18n from '../../../i18n';

const {
  startLoadingData,
  finishLoadingData,
  setData,
  setLoadingDataError,
  startSaving,
  finishSaving,
  setSavingError,
} = slice.actions;

const fetchWordsListData = (id: string): AppThunk => async (dispatch) => {
  dispatch(startLoadingData());
  try {
    const { data: wordsList } = await API.wordsList.getOne(id);

    dispatch(setData({ data: wordsList }));
  } catch (e) {
    const { response } = e as AxiosError<ApiError>;
    console.error(`❌ Failed to fetch list ${id}:`, response?.data);
    dispatch(setLoadingDataError(response?.data || null));
  } finally {
    dispatch(finishLoadingData());
  }
};

const saveWordList = (
  id: string,
  values: {
    name: string;
    description: string;
    words: any[];
  },
  skipRedirect = false,
): AppThunk => async (dispatch) => {
  dispatch(startSaving());

  try {
    const payload = {
      name: values.name,
      description: values.description ?? '',
      words: values.words,
    };

    console.log(`💾 Saving list ${id}:`, {
      name: payload.name,
      wordsCount: payload.words?.length,
    });

    const { data: wordsList } = await API.wordsList.save(id, payload);

    console.log(`✅ List ${id} saved successfully`);

    dispatch(setData({ data: wordsList }));
    dispatch(fetchFolderTreeWithLists(true));

    if (!skipRedirect) {
      history.push(Path.WORDS_LIST);
    }
  } catch (e) {
    const { response } = e as AxiosError<ApiError>;
    console.error(`❌ Failed to save list ${id}:`, response?.data);
    dispatch(setSavingError(response?.data || null));
    message.error(i18n.t('words-list:save.messages.error'));
  } finally {
    dispatch(finishSaving());
  }
};

export {
  fetchWordsListData,
  saveWordList,
  setLoadingDataError,
};
